











































































































import TheTemplateM from "@/general/components/templates/TheTemplateM.vue";
import InputRadio from "@/common/components/atoms/InputRadio.vue";
import FormLabel from "@/common/components/organisms/FormLabel.vue";
import ValidationErrorText from "@/common/components/atoms/ValidationErrorText.vue";
import ModalMain from "@/common/components/organisms/ModalMain.vue";
import { extend, ValidationProvider, ValidationObserver } from "vee-validate";
import { required, max } from "vee-validate/dist/rules";
import { Vue, Component, Prop, Ref, Watch} from "vue-property-decorator";
import commons from "@/common/store/modules/commons";

import modalState from "@/common/store/modules/modalState";
import { getThanksPointName } from "@/common/assets/js/utils/pointName";
import SettingsApi from "@/general/api/settingsApi";
import { MailDeliverySetting } from "@/general/store/models";
import SITE_MAP from "@/general/mixins/const/custom/sitemap";
import CONST_DATA from "@/general/mixins/const/constData";
import auth from "@/general/store/modules/auth";
import AuthStorage from "@/general/utils/auth";
import loginInfo from "@/general/store/modules/loginInfo";
import AuthApi from "@/general/api/authApi";
import LocalStorage from "@/general/utils/storage";

extend("required", {
  ...required,
  message: "{_field_}を入力してください。"
});
extend("max", {
  ...max,
  message: "{_field_}は{length}文字以内を入力してください。"
});
@Component({
  components: {
    TheTemplateM,
    InputRadio,
    FormLabel,
    ValidationErrorText,
    ValidationProvider,
    ValidationObserver,
    ModalMain
  }
})
export default class MailDeliverySettings extends Vue {
  formData: any = [];

  @Ref("form") form!: HTMLFormElement;
  @Prop({ type: Number, default: 1 }) id!: number;
  @Prop({ type: String, default: "", required: false }) modal!: string;
  @Prop({ type: Boolean, required: false, default: false }) ssoFlg!: boolean;

  result: any = [];
  page!: number;
  pageSize!: number;
  hasUpdate = true;
  closeModalState = modalState.closeModalState;
  changeModal: any = "";
  modalName = this.modal;
  roleType = null;
  isGroupBudget = false;
  groupBudgetName ="";
  isLoading = true;

  wantMailList = [
    {
      key: "want_point_given_mail",
      label: "ポイント受取通知メール",
      value: "1",
      show: false
    },
    {
      key: "want_point_balance_mail",
      label: "ポイント残高通知メール",
      value: "1",
      show: false
    },
    {
      key: "want_point_expiration_mail",
      label: "ポイント有効期限通知メール",
      value: "1",
      show: false
    },
    {
      key: "approval_result_notification_mail",
      label: "サンクスポイント承認/否認結果通知メール",
      value: "1",
      show: false
    },
    {
      key: "want_mailmagazine",
      label: "メールマガジン",
      value: "1",
      show: false
    }
  ];

  wantMailListForGroupBudget = [
    {
      key: "gb_want_point_given_mail",
      label: "GroupBudgetポイント受取通知メール",
      value: "1",
      show: false
    },
    {
      key: "gb_want_point_balance_mail",
      label: "GroupBudgetポイント残高通知メール",
      value: "1",
      show: false
    },
    {
      key: "gb_want_point_expiration_date",
      label: "GroupBudgetポイント有効期限通知メール",
      value: "1",
      show: false
    },
  ];

  breadcrumb = [
    {
      text: "",
      url: SITE_MAP.TOP_PAGE,
      pageType: "home"
    },
    {
      text: "メール受信設定",
      url: "",
      pageType: "lower"
    }
  ];

  buttonTitle = "キャンセル";

  get urls() {
    return {
      mypage: SITE_MAP.MY_PAGE
    };
  }

  wantMail: any = {
    want_point_given_mail: "",
    want_point_balance_mail: "",
    want_point_expiration_mail: "",
    approval_result_notification_mail: "",
    want_mailmagazine: "",
    gb_want_point_given_mail: "",
    gb_want_point_balance_mail: "",
    gb_want_point_expiration_date: ""
  };

  @Watch("closeModalState")
  onCloseModalState() {
    modalState.changeModal("");
  }

  closeModal() {
    this.modalName = "";
  }
  submit(ObserverProps: any) {
    ObserverProps.passes(async () => {
      const result = this.userNotificationSettings;
      const updres = await SettingsApi.postMailDeliverySetting(
        result.point_receipt,
        result.point_balance,
        result.point_expiration_date,
        result.thanks_point_result,
        result.magazine,
        result.user,
        result.gb_point_receipt,
        result.gb_point_balance,
        result.gb_point_expiration_date
      );

      if (updres.status == 400) {
        alert(updres.data.error);
      } else if (updres.status == 500) {
        if (this.ssoFlg) {
          // SSOログイン時は行き止まりエラー画面へ
          window.location.href = "/session-time-out/";
        } else {
          LocalStorage.removeAll();
          AuthApi.getLogout();
          auth.remove();
          window.location.href = "/system-error/";
        }
      } else {
        window.location.href = "/my-page/mailDeliverySettingsUpdated.html";
      }
    });
  }

  mounted() {
    AuthStorage.checkLogin();
  }

  async created() {
    this.ssoFlg = loginInfo.isSso;
    await commons.setOrgPageSpecificDataFromLocalStorage();

    const profileDataString = await AuthApi.getICSession();
    const profileData = JSON.parse(profileDataString);
    this.roleType = profileData.roleType;
    this.isGroupBudget = profileData.isGroupBudget;
    this.groupBudgetName = profileData.groupBudgetName;

    if (profileData.isGroupBudgetMode === true) {
      if (this.ssoFlg) {
        // SSOログイン時は行き止まりエラー画面へ
        window.location.href = "/session-time-out/";
      } else {
        LocalStorage.removeAll();
        AuthApi.getLogout();
        auth.remove();
        window.location.href = "/system-error/";
      }
      return;
    }

    const mailSetting: MailDeliverySetting = await SettingsApi.getMailDeliverySettingRead();

    this.wantMail.want_point_given_mail =
      mailSetting.user_point_receipt === true ? "1" : "2";
    this.wantMail.want_point_balance_mail =
      mailSetting.user_point_balance === true ? "1" : "2";
    this.wantMail.want_point_expiration_mail =
      mailSetting.user_point_expiration_date === true ? "1" : "2";
    this.wantMail.approval_result_notification_mail =
      mailSetting.user_thanks_point_result === true ? "1" : "2";
    this.wantMail.want_mailmagazine =
      mailSetting.user_mail_magazine === true ? "1" : "2";
    this.wantMail.gb_want_point_given_mail =
      mailSetting.user_gb_point_receipt === true ? "1" : "2";
    this.wantMail.gb_want_point_balance_mail =
      mailSetting.user_gb_point_balance === true ? "1" : "2";
    this.wantMail.gb_want_point_expiration_date =
      mailSetting.user_gb_point_expiration_date === true ? "1" : "2";


    this.wantMailList[0].show =
      mailSetting.org_point_receipt_notification_enabled;
    this.wantMailList[1].show =
      mailSetting.org_point_balance_notification_enabled;
    this.wantMailList[2].show =
      mailSetting.org_point_expiry_notification_enabled;
    this.wantMailList[3].show =
      mailSetting.approval_result;
    this.wantMailList[4].show = mailSetting.org_mail_magazine_enabled;

    this.wantMailList[3].label = this.thanksPointName + "承認/否認結果通知メール";

    //メール受信設定の項目をgroupbudgetNameをもとに再設定
    this.wantMailListForGroupBudget[0].label =
      "受取通知メール";
    this.wantMailListForGroupBudget[1].label =
      "残高通知メール";
    this.wantMailListForGroupBudget[2].label =
      "有効期限通知メール";

    this.wantMailListForGroupBudget[0].show =
      mailSetting.org_is_gb_point_receipt
    this.wantMailListForGroupBudget[1].show =
      mailSetting.org_is_gb_point_balance
    this.wantMailListForGroupBudget[2].show =
      mailSetting.org_is_gb_point_expiration_date
     
    this.hasUpdate =
      this.wantMailList[0].show ||
      this.wantMailList[1].show ||
      this.wantMailList[2].show ||
      this.wantMailList[3].show ||
      this.wantMailList[4].show ||
      this.wantMailListForGroupBudget[0].show ||
      this.wantMailListForGroupBudget[1].show ||
      this.wantMailListForGroupBudget[2].show

    this.buttonTitle = this.hasUpdate ? this.buttonTitle : "戻る";

    this.isLoading = false;

    await commons.getBreadcrumb(this.breadcrumb);

    if (this.modal) {
      this.changeModal(this.modal);
    }
  }

  get isGroupBudgetMailHiddenUser(){
    return commons?.userInfo.groupBudgetMode
  }

  get userNotificationSettings() {
    const point_receipt: boolean =
      this.wantMail.want_point_given_mail == "1" ? true : false;
    const point_balance: boolean =
      this.wantMail.want_point_balance_mail == "1" ? true : false;
    const point_expiration_date: boolean =
      this.wantMail.want_point_expiration_mail == "1" ? true : false;
    const thanks_point: boolean =
      this.wantMail.approval_result_notification_mail == "1" ? true : false;
    const magazine: boolean =
      this.wantMail.want_mailmagazine == "1" ? true : false;

    const userDetails = auth.user;

    const gb_point_receipt: boolean =
      this.wantMail.gb_want_point_given_mail == "1" ? true : false;
    const gb_point_balance: boolean =
      this.wantMail.gb_want_point_balance_mail == "1" ? true : false;
    const gb_point_expiration_date: boolean =
      this.wantMail.gb_want_point_expiration_date == "1" ? true : false;

    return {
      user: userDetails.user_id,
      point_receipt: point_receipt,
      point_balance: point_balance,
      point_expiration_date: point_expiration_date,
      thanks_point_result: thanks_point,
      magazine: magazine,
      gb_point_receipt: gb_point_receipt,
      gb_point_balance: gb_point_balance,
      gb_point_expiration_date: gb_point_expiration_date
    };
  }

  get thanksPointName() {
    return getThanksPointName(CONST_DATA.POINT_NAME.THANKS_POINT_DEFAULT_NAME1);
  }
}
